module.exports = __webpack_public_path__ + "static/media/amazon_back.c09f1ae9.png";